import { Table } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'
import { faMobileAlt } from '@fortawesome/pro-solid-svg-icons'

import { ButtonGroup, Card, CardBody, CardHeader } from 'Components/_theme'
import { ModalErrorState } from 'Components/ModalErrorState/ModalErrorState'

import { formatDate } from 'Utilities'

import type { DepotStockModalProps } from './DepotStockModal.types'

export const DepotStockModal = (props: DepotStockModalProps) => {
  const { hide, stocklistItems } = props
  const { deviceDefinition, imeis } = stocklistItems

  const intl = useIntl()

  if (!deviceDefinition) {
    return <ModalErrorState />
  }

  return (
    <Card>
      <CardHeader icon={faMobileAlt}>{deviceDefinition.name}</CardHeader>

      <CardBody>
        {!deviceDefinition && <ModalErrorState />}

        {deviceDefinition &&
          (imeis.length === 0 ? (
            <FormattedMessage
              id="DepotStockModal_no_available"
              values={{
                name: deviceDefinition.name,
              }}
            />
          ) : (
            <Table responsive size="sm">
              <thead>
                <tr>
                  <th>
                    <FormattedMessage id="IMEI" />
                  </th>

                  <th>
                    <FormattedMessage id="DepotStockModal_serial_number" />
                  </th>

                  <th>
                    <FormattedMessage id="DepotStockModal_eid" />
                  </th>

                  <th className="text-nowrap">
                    <FormattedMessage id="DepotStockModal_in_depot_since" />
                  </th>
                </tr>
              </thead>

              <tbody>
                {imeis.map(imei => (
                  <tr key={imei.id}>
                    <td>{imei.imei || '-'}</td>

                    <td>{imei.serialNumber || '-'}</td>

                    <td>{imei.eid || '–'}</td>

                    <td>
                      {formatDate(imei.depotAssignedAt) || (
                        <FormattedMessage id="DepotStockModal_unknown" />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ))}

        <ButtonGroup
          rightButton={{
            onClick: hide,
            text: intl.formatMessage({ id: 'Close' }),
          }}
        />
      </CardBody>
    </Card>
  )
}
